import React, { useMemo } from 'react';
import { UndeliverableReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';
import { useNewBadge } from '@/utils';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

import { useUndeliverableMailBriefQuery } from './queries';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'undeliverable-mail-report-card';

// Badge start date (UTC) — the NEW badge will display for 60 days from this date
const BADGE_START_DATE = '2026-08-18T00:00:00Z';
const UndeliverableMailReportCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();
  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);

  const { data: flaggedCount, isLoading } = useUndeliverableMailBriefQuery();
  const isNew = useNewBadge(BADGE_START_DATE);
  const childrenNode = useMemo(() => {
    if (!isSystem && flaggedCount != null) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          testId={TEST_ID}
          title="Flagged addresses"
          items={[
            {
              label: 'Employees',
              value: flaggedCount != null ? `${flaggedCount}` : '',
            },
          ]}
        />
      );
    }
    return null;
  }, [isLoading, isSystem, flaggedCount]);

  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.UndeliverableAddress);

  return (
    <ReportCardBase
      isNew={isNew}
      testId={TEST_ID}
      isWideMode={isFavoriteMode}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      url={ROUTES.UNDELIVERABLE_MAIL_REPORT}
      icon={
        <UndeliverableReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Undeliverable Mail"
      description="Employee addresses flagged due to returned mail"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default UndeliverableMailReportCard;
